import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"

import useSortData from './useSortData';


export default function useOrders(props, emit, orderData) {

    // Get toast interface
    const toast = useToast()

    const orderStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const loading = ref(false)


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getOrders = (url = null) => {
        store.dispatch("getOrders", {
            url,
            search: search.value,
            status: orderStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true

        if (orderData.value.id) {
            store.dispatch('updateOrder', orderData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("سفارش مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getOrders")
                        closeModal()
                    }
                })
        } else {
            console.log('Error');
        }
    }

    const closeModal = () => {
        show.value = false
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getOrders);

    const sortOrders = (field) => {
        sortData(field);
        getOrders();
    };


    return {
        show,
        orderStatus,
        search,
        perPage,
        sortField,
        sortDirection,
        loading,
        getOrders,
        onSubmit,
        closeModal,
        sortOrders,
    }
}